import * as XLSX from 'xlsx';

// Parse raw file bytes (from File.arrayBuffer()) into a workbook + sheet names.
// cellDates:true makes real date cells come back as JS Date objects (correct
// across the Excel 1900 leap-year bug) so coerce.parseDate handles them directly.
export function parseFileData(data) {
  const workbook = XLSX.read(data, { type: 'array', cellDates: true });
  return { sheetNames: workbook.SheetNames || [], workbook };
}

// Convert one sheet to an array-of-arrays. header:1 yields positional rows;
// blankrows:true and defval:null keep indices aligned to the source file so
// header-row detection by index stays correct.
export function getSheetRows(workbook, sheetName) {
  const sheet = workbook.Sheets[sheetName];
  if (!sheet) return [];
  return XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    raw: true,
    defval: null,
    blankrows: true,
  });
}
